module.exports = __webpack_public_path__ + "img/tm_interview_main_bg1.e56bac1b.png";